<template lang="pug">
.slider-container(
    v-if="slides && slides.length",
    ref="container",
    :class="[spacingTop, spacingBottom]",
    :style="{ maxHeight: `${height}px` }"
)
    easy-slider(
        v-if="width && height",
        animation="fade",
        :height="`${height}px`",
        :autoplay="true",
        :interval="5000",
        :stop-on-hover="true",
        :touch="false"
    )
        easy-slider-item.slide(v-for="(slide, i) in slides", :key="slide.id")
            Slide(:slide="slide", :max-width="width", max-height="auto")
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider';
import { get, cloneDeep, debounce } from '@/helpers';
import tailwind from '@/../tailwind.config.js';
import Slide from './Slide';

export default {
    name: 'Slider',
    data() {
        return {
            width: undefined,
            maxHeight: undefined
        };
    },
    props: {
        // slides: {
        //     type: Array,
        //     default: () => [],
        // },
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Slide,
        EasySlider: Slider,
        EasySliderItem: SliderItem
    },
    computed: {
        settings() {
            return get(this.section, 'settings') || [];
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        sliderHeight() {
            let sliderHeight = 200;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'sliderHeight');
                if (setting && setting.value !== undefined) sliderHeight = parseInt(setting.value);
            }
            return sliderHeight;
        },

        slides() {
            let slides = this.section.contents || [];
            return cloneDeep(slides).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        },

        height() {
            const md = parseInt(tailwind.theme.screens.md);
            const lg = parseInt(tailwind.theme.screens.lg);

            let fr = this.sliderHeight;
            let height;

            if (this.width && window.innerWidth <= md) {
                height = fr;
            } else if (this.width && window.innerWidth <= lg) {
                height = 1.5 * fr;
            } else {
                height = 2 * fr;
            }

            return height;
        }
    },
    methods: {
        debouncedCalculateMaxWidth: debounce(self => {
            if (self.$refs.container) {
                const style = getComputedStyle(self.$refs.container);
                self.width = self.$refs.container.clientWidth;
                self.width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            }
        }, 100)
    },
    mounted() {
        window.addEventListener('resize', () => this.debouncedCalculateMaxWidth(this));
        this.$nextTick(this.debouncedCalculateMaxWidth(this));
    },

    destroyed() {
        window.removeEventListener('resize', () => this.debouncedCalculateMaxWidth(this));
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.slider-container
    background: $cc-blue
::v-deep
    @media only screen and (max-width: 1320px)
    .slide
      width: 100%
      height: 100%
      figure
        width: 100%
        height: 100%
        img
          object-fit: cover
          width: 100% !important
          height: 100% !important

    .slider-btn
        background: initial
    .slider-icon
        width: 18px
        height: 18px
        border-left: 2px solid #fff
        border-bottom: 2px solid #fff
    .slider
        overflow: visible
    .slider-items
        overflow: hidden
    .slider-indicators
        bottom: 25px
    .slider-indicator-icon
        border-radius: 10px
        border: 1px solid #fff
        background-color: transparent
        margin: 0 .2rem
        width: 10px
        height: 10px
        transition: background-color 0.2s linear, border-color 0.2s linear
    .slider-indicator-active
        background-color: #fff
</style>
